/**
 * ProductWithCode — compact "{client_product} [CODE]" display.
 * The product name may truncate; the contract-code chip never does.
 * Full "{product} - {code}" text is exposed via the title tooltip.
 * Used by OrdersTable, ProcessorOrders, Fulfillment snapshot and the edit modal.
 */
import React from 'react';

export const productDisplayText = (product, code) =>
  code ? `${product || 'N/A'} - ${code}` : (product || 'N/A');

export const ContractCodeChip = ({ code, testId, size = 'sm' }) => {
  if (!code) return null;
  const sizing = size === 'xs' ? 'text-[9.5px] px-1 py-px' : 'text-[10.5px] px-1.5 py-px';
  return (
    <span
      className={`inline-flex items-center shrink-0 rounded font-mono font-semibold tracking-wide leading-4 bg-slate-100 text-slate-700 border border-slate-200 ${sizing}`}
      data-testid={testId}
    >
      {code}
    </span>
  );
};

export const ProductWithCode = ({ product, code, testId, codeTestId, className = '', size = 'sm' }) => {
  const name = product || 'N/A';
  return (
    <span
      className={`inline-flex items-center gap-1.5 min-w-0 max-w-full ${className}`}
      title={productDisplayText(product, code)}
      data-testid={testId}
    >
      <span className="truncate min-w-0">{name}</span>
      <ContractCodeChip code={code} testId={codeTestId} size={size} />
    </span>
  );
};
